"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _labelConsts = require("01_core/constants/labelConsts");
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _KunrenDocMngCondition = _interopRequireDefault(require("./components/KunrenDocMngCondition"));
var _KunrenDocMngResult = _interopRequireDefault(require("./components/KunrenDocMngResult"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ドキュメント管理（訓練）画面
 */
class KunrenDocMngMain extends _react.default.Component {
  componentDidMount() {
    const {
      scrollY,
      noSticky
    } = this.props.scrollTop;
    if (noSticky) {
      _windowUtil.default.windowScroll(scrollY);
    } else {
      window.scrollTo(0, 0);
    }
  }
  render() {
    const {
      intl
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_DOCUMENT_MNG_KUNREN
      })
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_KunrenDocMngCondition.default, {
      isNewWindow: true
    }), /*#__PURE__*/_react.default.createElement(_KunrenDocMngResult.default, {
      isNewWindow: true
    })));
  }
}
const mapStateToProps = state => ({
  scrollTop: state.bcmKunren.scrollTop
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIntl.injectIntl)(KunrenDocMngMain));